import React from "react";
import { useAppSelector } from "../../../../store/reduxHooks";
import { UI_ModuleInfo } from "../../../../UI_ITO/indexUI";
import { SELECT_CLIENT_FOR_AGENT } from "../../../../store/selectors/listClientForAgentSelector";
import { IData } from "../../../../interfaces/IData";

/**
 * Компонент отображает информацию о клиенте
 */
export function ClientInfo(): JSX.Element | null {
  const selectedClient = useAppSelector(SELECT_CLIENT_FOR_AGENT);
  const data: IData[] = [
    {
      name: "Наименование организации",
      value: `${selectedClient.name}`,
      type: { link: "div", color: "black" },
    },
    {
      name: "ИНН",
      value: `${selectedClient.inn}`,
      type: { link: "div", color: "black" },
    },
    {
      name: "ОГРН",
      value: `${selectedClient.ogrn}`,
      type: { link: "div", color: "black" },
    },
    {
      name: "Почтовый адрес",
      value: `${selectedClient.email}`,
      type: { link: "div", color: "black" },
    },
    {
      name: "Телефон",
      value: `${selectedClient.phone_number}`,
      type: { link: "div", color: "black" },
    },
  ];
  const filledData = data?.filter(
    (item) => item.value !== "null" && item.value !== "undefined" && item.value,
  );

  if (filledData?.length === 0) return null;

  return <UI_ModuleInfo data={filledData} title="Клиент" />;
}
